export default "__VITE_ASSET__99e918f3__"